module.exports = __webpack_public_path__ + "img/ico-search.71012acc.svg";